var __jsx = React.createElement;
import React, { useRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CarSaleCard from "./CarSaleCard";
import { useLang } from "@/common/Contexts/LanguageContext";
import { Icon } from "@syarahtech/ui";
import useIsMobile from "@hooks/useIsMobile";
var CarSaleCardCarousel = function CarSaleCardCarousel(_ref) {
  var cards = _ref.cards,
    _ref$autoPlay = _ref.autoPlay,
    autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay,
    _ref$autoPlayInterval = _ref.autoPlayInterval,
    autoPlayInterval = _ref$autoPlayInterval === void 0 ? 5000 : _ref$autoPlayInterval,
    onBookAppointment = _ref.onBookAppointment,
    onSlideChange = _ref.onSlideChange,
    onRefetch = _ref.onRefetch;
  var lang = useLang();
  var isRTL = lang === "ar";
  var isMobile = useIsMobile();
  var carouselRef = useRef(null);
  var responsive = {
    desktop: {
      breakpoint: {
        max: 3000,
        min: 1024
      },
      items: 1,
      slidesToSlide: 1
    },
    tablet: {
      breakpoint: {
        max: 1024,
        min: 640
      },
      items: 1,
      slidesToSlide: 1
    },
    mobile: {
      breakpoint: {
        max: 640,
        min: 0
      },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 0
    }
  };
  var handlePrev = function handlePrev() {
    if (carouselRef.current) {
      carouselRef.current.previous();
    }
  };
  var handleNext = function handleNext() {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  // Custom dot component with sliding window (max 5 bullets)
  var CustomDot = function CustomDot(_ref2) {
    var _carouselState$curren;
    var onClick = _ref2.onClick,
      active = _ref2.active,
      index = _ref2.index,
      carouselState = _ref2.carouselState;
    var total = cards.length;
    var currentSlide = (_carouselState$curren = carouselState === null || carouselState === void 0 ? void 0 : carouselState.currentSlide) !== null && _carouselState$curren !== void 0 ? _carouselState$curren : 0;
    var maxDots = 5;

    // Calculate which dots to show (sliding window)
    var visibleIndices = [];
    if (total <= maxDots) {
      // Show all dots if total is 5 or less
      visibleIndices = Array.from({
        length: total
      }, function (_, i) {
        return i;
      });
    } else {
      // Sliding window logic for more than 5 cards
      if (currentSlide < 2) {
        // At the beginning: show [0, 1, 2, 3, 4]
        visibleIndices = [0, 1, 2, 3, 4];
      } else if (currentSlide >= total - 3) {
        // At the end: show last 5
        visibleIndices = [total - 5, total - 4, total - 3, total - 2, total - 1];
      } else {
        // In the middle: show 2 before, current, 2 after
        visibleIndices = [currentSlide - 2, currentSlide - 1, currentSlide, currentSlide + 1, currentSlide + 2];
      }
    }

    // Only render if this dot should be visible
    if (!visibleIndices.includes(index)) {
      return null;
    }
    return /*#__PURE__*/React.createElement("button", {
      onClick: onClick,
      className: "react-multi-carousel-dot ".concat(active ? "react-multi-carousel-dot--active" : ""),
      style: {
        border: "none",
        background: active ? "#1E40AF" : "#D1D5DB",
        width: active ? "32px" : "20px",
        height: "8px",
        borderRadius: "4px",
        transition: "all 0.3s",
        outline: "none",
        margin: "0 4px",
        cursor: "pointer"
      },
      "aria-label": "Go to slide ".concat(index + 1)
    });
  };
  if (cards.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "car-sale-carousel-wrapper",
    className: "w-full mt-10 md:my-1 mx-auto relative"
  }, /*#__PURE__*/React.createElement("style", null, "\n          .carousel-container-custom {\n            position: relative;\n            padding: 0 ".concat(isMobile ? "0" : "80px", ";\n            ").concat(!isMobile ? "max-width: 1100px; margin: 0 auto;" : '', "\n          }\n\n          .carousel-container-custom .react-multi-carousel-list {\n            overflow: visible;\n          }\n\n          .carousel-container-custom .react-multi-carousel-track {\n            gap: ").concat(isMobile ? "0" : "16px", ";\n          }\n\n          .carousel-container-custom .react-multi-carousel-item {\n            padding: ").concat(isMobile ? "0 8px" : "0", ";\n            ").concat(!isMobile ? 'max-width: 915px !important; width: 915px !important; flex: 0 0 915px !important;' : 'min-width: 320px;', "\n          }\n\n          .carousel-container-custom .react-multi-carousel-item > div {\n            height: 100%;\n          }\n\n          /* Hide default arrows */\n          .carousel-container-custom .react-multiple-carousel__arrow {\n            display: none !important;\n          }\n\n          /* Style the dots container */\n          .carousel-container-custom .react-multi-carousel-dot-list {\n            position: static !important;\n            margin-top: ").concat(isMobile ? "24px" : "56px", ";\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            gap: 0;\n            bottom: auto !important;\n          }\n\n          /* Hover effect for dots */\n          .carousel-container-custom .react-multi-carousel-dot-list button:hover:not(.react-multi-carousel-dot--active) {\n            background: #9CA3AF !important;\n          }\n\n          /* Navigation wrapper */\n          .navigation-wrapper {\n            position: relative;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 24px;\n          }\n\n          /* Custom arrow buttons */\n          .custom-arrow {\n            width: 48px;\n            height: 48px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            z-index: 10;\n          }\n\n          @media (max-width: 1024px) {\n            .custom-arrow {\n              display: none;\n            }\n          }\n        ")), /*#__PURE__*/React.createElement("div", {
    id: "car-sale-carousel-container",
    className: "carousel-container-custom"
  }, /*#__PURE__*/React.createElement(Carousel, {
    ref: carouselRef,
    responsive: responsive,
    infinite: false,
    autoPlay: false,
    keyBoardControl: true,
    customTransition: "transform 500ms ease-in-out",
    transitionDuration: 500,
    containerClass: "carousel-container",
    itemClass: "carousel-item-padding",
    arrows: false,
    showDots: cards.length > 1,
    renderDotsOutside: true,
    customDot: /*#__PURE__*/React.createElement(CustomDot, null),
    rtl: isRTL,
    swipeable: true,
    draggable: true,
    afterChange: function afterChange(_previousSlide, _ref3) {
      var currentSlide = _ref3.currentSlide;
      onSlideChange === null || onSlideChange === void 0 ? void 0 : onSlideChange(currentSlide);
    }
  }, cards.map(function (card, index) {
    return /*#__PURE__*/React.createElement("div", {
      id: "car-sale-carousel-item-".concat(index),
      key: "".concat(card.request_id || index),
      className: "h-full flex"
    }, /*#__PURE__*/React.createElement(CarSaleCard, {
      sellTradeItem: card,
      onBookAppointment: onBookAppointment,
      onRefetch: onRefetch
    }));
  })), cards.length > 1 && !isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-carousel-next-arrow",
    onClick: handleNext,
    className: "custom-arrow",
    style: {
      position: "absolute",
      bottom: "-20px",
      left: "50%",
      transform: "translateX(-120px)"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-back-ios",
    className: "text-primary-new",
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("div", {
    id: "car-sale-carousel-prev-arrow",
    onClick: handlePrev,
    className: "custom-arrow",
    style: {
      position: "absolute",
      bottom: "-20px",
      left: "50%",
      transform: "translateX(72px)"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-forward-ios",
    className: "text-primary-new",
    width: 6,
    height: 6
  })))));
};
export default CarSaleCardCarousel;